import type { UserModel } from "~/models/User.model";
import { useAuthStore } from "~/stores/auth";

// Cache duration: 60 seconds
const CACHE_DURATION_MS = 60 * 1000;

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();
  const now = Date.now();
  const lastCheck = authStore.lastPasswordCheckTimestamp;

  // if (now - lastCheck > CACHE_DURATION_MS) {
  //   await useNuxtApp().$authService.checkIfCanManageUserAccount();
  //   authStore.setLastPasswordCheckTimestamp(now);
  // }

  return true;
});
